import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container, Box } from '@mantine/core';

// Import AWS components with updated paths
import LandingPage from './components/LandingPage';
import AWSCredentialsPage from './components/AWSCredentialsPage';
import AWSExportPage from './components/AWSExportPage';
import AWSImportPage from './components/AWSImportPage';
import SolnStudioApp from './solnstudio/SolnStudioApp';
// LucidAuthCallback import removed - now handled at main app level

// Import AWS context from shared location
import { CredentialsProvider } from '../../shared/contexts/CredentialsContext';

// Import Footer component
import Footer from '../../components/Footer';

function AwsApp({ onBackToPlatformSelector }) {
  return (
    <CredentialsProvider>
      <Box style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Container size="xl" style={{ flex: 1, padding: '20px' }}>
          {/* AWS Platform Routes */}
          <Routes>
            <Route path="/" element={<LandingPage onBackToPlatformSelector={onBackToPlatformSelector} />} />
            <Route path="/aws-credentials" element={<AWSCredentialsPage onBackToPlatformSelector={onBackToPlatformSelector} />} />
            <Route path="/export" element={<AWSExportPage onBackToPlatformSelector={onBackToPlatformSelector} />} />
            <Route path="/import" element={<AWSImportPage onBackToPlatformSelector={onBackToPlatformSelector} />} />
            {/* Solution Studio — Design / Build / Test sub-app (routes at /solution-studio/*) */}
            <Route path="/solution-studio/*" element={<SolnStudioApp />} />
            {/* Note: /auth/lucid/callback is now handled at main app level for proper OAuth flow */}

            {/* Redirect any unknown routes to AWS landing page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Container>

        {/* Footer with AWS orange theme */}
        <Footer platformColor="orange" />
      </Box>
    </CredentialsProvider>
  );
}

export default AwsApp;